import { departmentConstants } from "../constant/department.constants";

export const initialState = {
    department: {
        id: '',
        departmentCode: '',
        departmentName: ''
    },
    dataDepartment: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const departmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case departmentConstants.GET_SUCCESS:
            return {
                ...state,
                dataDepartment: action.departmentList,
                isLoading: false
            };
        case departmentConstants.ADD_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };
        case departmentConstants.ADD_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        case departmentConstants.DELETE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case departmentConstants.DELETE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        case departmentConstants.UPDATE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case departmentConstants.UPDATE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        default:
            return state;
    }
};

export default departmentReducer;
